import { TabProps } from '@/stories/Tab/Tab';
import { useCallback, useEffect, useState } from 'react';
import ARROW from '../assets/images/replay/view-more.svg';
import VideoItem from '../components/replay/VideoItem';
import useMobile from '../hooks/useMobile';
import { EpisodeInfo, YoutubeVideo } from "../services/models";
import { videoService } from "../services/video";
import SlideTab from '../stories/Tab/SlideTab';
import * as S from './Replay.styled';
import { useRecoilState, useRecoilValue } from 'recoil';
import { episodeInfoState, replayVideoListState, replayVideoState } from '../utils/recoil/atoms';
import { useQuery } from '@tanstack/react-query';

export default function Replay() {
  const episodeInfo = useRecoilValue(episodeInfoState)
  const replayVideo = useRecoilValue(replayVideoState)
  const [replayVideoList, setReplayVideoList] = useRecoilState(replayVideoListState)
  

  let { isMobile } = useMobile()
  const [tabData, setTabData] = useState<TabProps[]>([]);
  const [activeTab, setActiveTab] = useState<string>('');
  const [replayTitle, setReplayTitle] = useState<string>('');

  type YearOfPageInfo = {
     total: number,
     page: number,
  }

  type PagingInfo = Record<string, YearOfPageInfo>
  const [paging, setPaging] = useState<PagingInfo>({});
  const videoSize = !isMobile? 9 : 8;


  const setTabs = () => {
    const tabs: TabProps[] = []
    replayVideo.forEach((item) => {
      tabs.push({
        label: `${item.year}년 ${item.no}회`,
        value: `${item.year}`,
      })
    })

    setTabData(tabs)
    setActiveTab(tabs[0].value)
  }

  const setPagingInfo = (items: YoutubeVideo[]) => {
    if (!activeTab) return
    
    if (paging) {
      if (!Object.keys(paging).includes(activeTab)) {
        setPaging(Object.assign(paging, {
          ...paging,
          [activeTab]: {
            total: items.length,
            page: 1
          }
        }))
      }
    } else {
      setPaging({
        [activeTab]: {
          total: items.length,
          page: 1
        }
      })
    }
  }

  const getYoutubePlayList = async () => {
    let result: YoutubeVideo[] = [];
    if (!activeTab) return result;
    const ids = replayVideo.find((video) => video.year === Number(activeTab))?.keys
    if (ids) {
      const lists = await Promise.all(ids.map(async (id) => {
        const res = await videoService.getYoutubePlayList(id)
        const items = res.items.filter((video) => video.snippet.title !== 'Private video').reverse()
        return items
      }))

      lists.map((list) => result.push(...list))

      setReplayVideoList(result);
    }
    setPagingInfo(result)
    return result
  }

  const { data: replayVideoListData, isLoading } = useQuery({
    queryKey: ['replayVideoList', activeTab],
    queryFn: getYoutubePlayList,
    enabled: !!activeTab
  })

  const onViewMore = async () => {
    setPaging({
      ...paging,
      [activeTab]: {
        total: paging[activeTab].total,
        page: paging[activeTab].page + 1
      }
    })
  };

  const getPagingPage = () => {
    return paging[activeTab].page
  }

  const getPagingTotal = () => {
    return paging[activeTab].total
  }

  useEffect(()=>{
    if (tabData.length === 0) {
      setTabs()
    }
  },[episodeInfo])

  useEffect(() => {
    const activeTabData = tabData.find((item: TabProps) => item.value === activeTab);
    if (activeTabData) {
      setReplayTitle(activeTabData.label);
    }
  }, [tabData, activeTab]);

  const ReplayVideoList = ({ videoList }: { videoList: YoutubeVideo[] }) => {
    console.log(videoList)
    return (
      <S.ReplayList>
        {videoList.map((item: YoutubeVideo) => (
          <VideoItem video={item} key={item.id} />
        ))}
      </S.ReplayList>
    );
  };

  return (
    <S.Replay>
      <h1>다시보기</h1>
      {tabData.length && <SlideTab tab={tabData} active={activeTab} onChange={setActiveTab} />}
      <hr className='hr' />
      <p className='replay-title nanum'>{replayTitle}</p>
      {
        !isLoading && Object.keys(paging).length > 0 && Object.keys(paging).includes(activeTab) && (
          <ReplayVideoList videoList={replayVideoList.filter((_, index) => index < getPagingPage() * videoSize)} />
        )
      }
      {paging && paging[activeTab] && (getPagingPage() * videoSize < getPagingTotal()) && (
        <div className='view-more'>
          <S.ViewMore onClick={onViewMore}>
            <span>더보기</span>
            <img src={ARROW} alt='' />
          </S.ViewMore>
        </div>
      )}
    </S.Replay>
  );
};
